import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {IExpense} from 'types/project';
import {ResponseData} from 'types/response-data';

const getProjectExpenses = api.injectEndpoints({
  endpoints: builder => ({
    getProjectExpenses: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `projects/${params.id}/expenses`,
        };
      },
    }),
  }),
});

type Request = {
  id?: ObjectId;
};

type Response = ResponseData<Array<IExpense>>;

export const {useGetProjectExpensesQuery} = getProjectExpenses;
